export const DURATION_UNITS = ['minutes', 'hours', 'days'] as const;
export type DurationUnit = (typeof DURATION_UNITS)[number];

const MINUTES_PER: Record<DurationUnit, number> = { minutes: 1, hours: 60, days: 24 * 60 };

/** The API keeps calendar minutes; the editor shows the largest unit that divides them evenly. */
export function toDurationParts(minutes: number | null): { value: string; unit: DurationUnit } {
  if (minutes === null) return { value: '', unit: 'hours' };
  if (minutes % MINUTES_PER.days === 0)
    return { value: String(minutes / MINUTES_PER.days), unit: 'days' };
  if (minutes % MINUTES_PER.hours === 0) {
    return { value: String(minutes / MINUTES_PER.hours), unit: 'hours' };
  }
  return { value: String(minutes), unit: 'minutes' };
}

/** Blank means "no time limit" (null); anything else must already be a whole positive number. */
export function toMinutes(value: string, unit: DurationUnit): number | null {
  const trimmed = value.trim();
  if (trimmed === '') return null;
  return Number(trimmed) * MINUTES_PER[unit];
}

export const isWholePositive = (value: string) => /^\d+$/.test(value.trim()) && Number(value) > 0;
